module.exports = {"152223100":"音德尔镇","152223101":"新林镇","152223102":"巴彦高勒镇","152223103":"胡尔勒镇","152223104":"阿尔本格勒镇","152223105":"巴达尔胡镇","152223106":"图牧吉镇","152223107":"好力保镇","152223201":"巴彦乌兰苏木","152223202":"宝力根花苏木","152223203":"阿拉达尔吐苏木","152223204":"巴彦扎拉嘎乡","152223205":"努文木仁乡","152223400":"内蒙古自治区图牧吉强制隔离戒毒所","152223401":"保安沼监狱","152223402":"乌兰监狱","152223403":"乌塔其监狱","152223404":"种畜场","152223405":"八一牧场","152223406":"巴达尔胡农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152223.json
// module id = 435
// module chunks = 0